// components/QuantityTableFragments/LocationNotesFragment.js
import React from 'react';
import { Row, Col, Label, Card } from 'reactstrap';
import {
  Editor,
  EditorProvider,
  Toolbar,
  BtnBold,
  BtnItalic,
  BtnBulletList,
  BtnClearFormatting,
  BtnLink,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnStyles,
  BtnUnderline,
  BtnUndo,
  HtmlButton,
  Separator,
} from 'react-simple-wysiwyg';

const DeliveryVesselFirstLocationNotes = ({
  form,
  deliveryincotermformData,
  handleDeliveryTextChangeIncoterm,
}) => {
  return (
    <Row>
      <Col sm={12}>
        <div className='mb-1'>
          <Label htmlFor='loc1NotesForSTS' className='form-label fw-semibold'>
            {deliveryincotermformData.incotermLocation2Name}
          </Label>
        </div>
      </Col>

      <Col sm={12}>
        <Label htmlFor='loc1NotesForSTS' className='form-label'>
          Notes
        </Label>
        <Card>
          <div className='snow-editor'>
            <EditorProvider>
              <Editor
                id='loc1NotesForSTS'
                name='loc1NotesForSTS'
                value={deliveryincotermformData.loc1NotesForSTS || ''}
                onChange={handleDeliveryTextChangeIncoterm('loc1NotesForSTS')}
                style={{ height: '150px', overflowY: 'auto' }}
              >
                <Toolbar>
                  <BtnBold />
                  <BtnItalic />
                  <BtnBulletList />
                  <BtnClearFormatting />
                  <BtnLink />
                  <BtnNumberedList />
                  <BtnRedo />
                  <BtnStrikeThrough />
                  <BtnStyles />
                  <BtnUnderline />
                  <BtnUndo />
                  <HtmlButton />
                  <Separator />
                </Toolbar>
              </Editor>
            </EditorProvider>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default DeliveryVesselFirstLocationNotes;
